// Google reCAPTCHA v3 helper. Silently no-ops when site key is not configured.
let scriptLoadPromise = null;

function loadScript(siteKey) {
  if (scriptLoadPromise) return scriptLoadPromise;
  scriptLoadPromise = new Promise((resolve, reject) => {
    if (typeof window === "undefined") return reject(new Error("no window"));
    if (window.grecaptcha && window.grecaptcha.execute) return resolve(window.grecaptcha);
    const s = document.createElement("script");
    s.src = `https://www.google.com/recaptcha/api.js?render=${encodeURIComponent(siteKey)}`;
    s.async = true;
    s.defer = true;
    s.onload = () => {
      if (window.grecaptcha) {
        window.grecaptcha.ready(() => resolve(window.grecaptcha));
      } else {
        reject(new Error("grecaptcha unavailable"));
      }
    };
    s.onerror = () => reject(new Error("recaptcha script failed"));
    document.head.appendChild(s);
  });
  return scriptLoadPromise;
}

/**
 * Execute reCAPTCHA v3 and return a token, or null if site key is not configured.
 * @param {string} siteKey - reCAPTCHA v3 site key from Settings
 * @param {string} action - action name (e.g. "enquiry")
 */
export async function getRecaptchaToken(siteKey, action = "enquiry") {
  if (!siteKey) return null;
  try {
    const grecaptcha = await loadScript(siteKey);
    return await grecaptcha.execute(siteKey, { action });
  } catch (e) {
    // eslint-disable-next-line no-console
    console.warn("reCAPTCHA execution failed", e);
    return null;
  }
}
